import { GeoJSONInfoSection } from "@/overlay/components/GeoJSONManage/GeoJSONInfoSection";
import { GeoJSONUploadSection } from "@/overlay/components/GeoJSONManage/GeoJSONUploadSection";
import { classNames } from "@/utility/jsx";
import { GeoJSONUploadedFilesSection } from "./GeoJSONUploadedFilesSection";
import styles from "./style.module.scss";

export function GeoJSONManage() {
  return (
    <div className={classNames(styles["file-manager"])}>
      <GeoJSONInfoSection />
      <GeoJSONUploadSection />
      <GeoJSONUploadedFilesSection />
    </div>
  );
}
